// tslint:disable:no-var-requires
const ItalyData = require('../data/italia_comuni.json');
// tslint:enable:no-var-requires


export const Addresses = {
  getProvinces: (asOptions?: boolean) => {
    const province = [];
    ItalyData.forEach(p => (province.push(p)));
    if (asOptions) {
      return province.map(p =>({label: p, value: p}));
    }
    return province;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/addresses.ts